import { useMemo, type FC } from "react";

import { useCurrentView } from "@ds/hooks/use-current-view";
import { useVisibility } from "@ds/hooks/use-visibility";

import { EntityTypeName } from "@ds/model/entity-model";

import { getPageTitleByTableDataType } from "@ds/modules/table-data/utils/helpers";
import { MainTableDataTypeEnum } from "@ds/modules/table-data/utils/model";

import { MainView } from "@ds/components/main-view";
import { TableTabMenu } from "@ds/components/table/table-tab-menu";

import { CampaignsTableActionsMenu } from "./components/common/campaigns-table-actions-menu";
import { CreateCampaignModal } from "./components/forms/create-campaign-form/create-campaign-modal";
import { DuplicateCampaignModal } from "./components/forms/duplicate-campaign-form/duplicate-campaign-modal";
import { CampaignInfo } from "./components/campaign-info";
import { CampaignsTable } from "./components/campaigns-table";

export const CampaignsMainPage: FC = () => {
  const [currentView] = useCurrentView();
  const [isCreateModalVisible, setIsCreateModalVisible] = useVisibility();
  const [isDuplicateModalVisible, setIsDuplicateModalVisible] = useVisibility();

  const filterOptions = useMemo(
    () => ({
      entityType: EntityTypeName.CONTENT_CAMPAIGN,
      tableType: MainTableDataTypeEnum.ContentCampaigns,
    }),
    [],
  );

  if (!currentView) {
    return null;
  }

  return (
    <>
      <MainView
        title={getPageTitleByTableDataType(filterOptions.tableType)}
        filterOptions={filterOptions}
        options={<TableTabMenu tableType={filterOptions.tableType} currentView={currentView} />}
        view={<CampaignsTable />}
        info={<CampaignInfo onCreateCampaign={setIsCreateModalVisible(true)} />}
        actions={
          <CampaignsTableActionsMenu
            onCreate={setIsCreateModalVisible(true)}
            onDuplicate={setIsDuplicateModalVisible(true)}
          />
        }
      />

      {isCreateModalVisible && <CreateCampaignModal onClose={setIsCreateModalVisible(false)} />}
      {isDuplicateModalVisible && <DuplicateCampaignModal onClose={setIsDuplicateModalVisible(false)} />}
    </>
  );
};
